//---------	Global imports
import React from 'react';
import Link from 'gatsby-link';

//---------	Plugins
import Bricks from 'bricks.js';
import { forOwn, filter, includes } from 'lodash';
 import { toast } from 'react-toastify';

//---------	Styles
import './styles.sass';

//---------	Translations
import { T } from '../../../translations'



class ProductsList extends React.Component {
  
  //---------	Constructor
  constructor(props) {
    super();

    this.productsList = props.productsList;
    this.pageReady = false;
    this.productsListGrid;
    this.state = {
      filteredProducts: [],
      stateTransition: false,
      stateZoomOut: false
    };
    
    this.gridLayout = this.gridLayout.bind(this);
  }
  
  
  //---------	React functions
  componentDidMount() {
    this.gridLayout();
    setTimeout(() => this.pageReady = true, 500);
  }
  
  componentWillReceiveProps(newProps) {
    this.filterProducts(newProps.filters);
  }
  
  
  //---------	Custom functions
  gridLayout() {
    this.productsListGrid = Bricks({
      container: '.CalipsyProductsList-products',
      packed: 'data-packed',
      sizes: [
        {columns: 1, gutter: 0},
        {mq: '600px', columns: 2, gutter: 20},
        {mq: '768px', columns: 2, gutter: 20},
        {mq: '992px', columns: 3, gutter: 20},
        {mq: '1120px', columns: 3, gutter: 30}
      ]
    });
    this.productsListGrid.pack().resize();
  }
  
  filterProducts(filters) {
    const products = [];
    const filteredProducts = filter(this.productsList, product => !includes(filters, product.category));
  
    forOwn(filteredProducts, (product, key) => products.push(
      <div key={key} className="CalipsyProductsList-product">
        <Link to={product.path}>
          <div className="CalipsyProductsList-image">
            <img src={product.thumbnail} alt={product.name}/>
            <button className="CalipsyButton"><span>{ T.shop.messages.viewDetails }</span></button>
          </div>
          <div className="CalipsyProductsList-details">
            <h5>{product.name} <span>from <strong>£{product.price}<sup>00</sup></strong></span></h5>
          </div>
        </Link>
      </div>
      )
    );
    
    
    this.setState({filteredProducts: products}, this.productsListGrid.pack);
    
    if (this.pageReady && window.innerWidth >= 768) {
      toast.info(<div className="filtersApplied info">{ T.global.filtersApplied }</div>, {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1500
      });
    }
  }
  
  
  //---------	Render
  render() {
    
    let productsTransitionClass = 'CalipsyProductsList-products';
    
    if (this.state.stateTransition) productsTransitionClass += ' state-transition';
    if (this.state.stateZoomOut) productsTransitionClass += ' state-zoomOut';
    
    return (
      <div className={productsTransitionClass}>
        {this.state.filteredProducts}
      </div>
    );
  }
}

export default ProductsList;


// WEBPACK FOOTER //
// ./src/components/ProductsList/index.js